import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';

import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

export default function FacultyEdit() {

  const [discipline, setDisciplineData] = useState([]);
  const [faculty, setFacultyData] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [message, setMessage] = useState("");
  const [facultyid, setFacultyname] = useState(false);


  const { http } = Api();
  let { id } = useParams();
  const decodedID = atob(id);
  sessionStorage.setItem("id", decodedID);


  const navigate = useNavigate();

  const isAuth = useAuth();

  if (isAuth === false) {
   navigate("/admin/")
  }

  const [errors, setErrors] = useState({spec_name: '', dname: '',fac: '',specstatus: '' });

  useEffect(() => {
    const { http } = Api();
    const id1 = sessionStorage.getItem("id");

    const fetchData = async () => {
      try {

        const response = await http.get(`/Admin/getspecialisation/${id1}`);
        const response1 = await http.get(`/Admin/getfaculty`);
        
        const response2 = await http.get(`/Admin/getdiscipline`, {
          params: {
            limit: '500'
          }
        });

        setDisciplineData(response2.data.data);
        setFacultyData(response1.data.data);
        setSpecialization(response.data.specialisation)
        console.log(response2);
      

      } catch (error) {

        setMessage("somthing went wrong");
        console.error('Error fetching faculty data:', error);

      }
    };

    fetchData();

   

  }, []);

  useEffect(() => {
    if (specialization.faculty_id) {
    
        setFacultyname(specialization.faculty_id);
      
    }
  }, [ specialization]);


  const isdisiplin = () => {

    const faculty_id = document.getElementById('faculty_id').value;
    setFacultyname(parseInt(faculty_id));
  }
  const validateForm = () => {

    const updatedErrors = {};
    let hasError = false;

    const specialization = document.getElementById('specialization').value;
    const specstatus = document.getElementById('status').value;
    const faculty_id = document.getElementById('faculty_id').value;
    const discipline_id = document.getElementById('discipline_id').value;


    if (!specialization) {

      updatedErrors.spec_name = 'Please enter a Specialization';
      hasError = true;     

    }
    if (!discipline_id) {

      updatedErrors.dname = 'Please select a Discipline';
      hasError = true;   

    }
    if (!faculty_id) {
      updatedErrors.fac = 'Please select a Faculty';
      hasError = true; 

    }
    if (specstatus === "0") {
      updatedErrors.specstatus = 'Please select a Status';
      hasError = true; 

    }
    if (hasError) 
    {
      setErrors(updatedErrors);
      if (!specialization) {
          document.getElementById('specialization').focus();
      } else if (!discipline_id) {
          document.getElementById('discipline_id').focus();
      } else if (!faculty_id) {
        document.getElementById('faculty_id').focus();
      }
      return false;
   } else {
      setErrors({ spec_name: '', dname: '',fac: '' ,specstatus: ''});
      return true;
   }
  };

  const cancelForm = () => {
    navigate("/admin/specialization");
    sessionStorage.removeItem("message", "Faculty updated successfully");
  };

  const saveForm = () => {


    if (validateForm()) {

      const id2 = sessionStorage.getItem("id");
      console.log(id2);


      const specialization = document.getElementById('specialization').value;
      const faculty_id = document.getElementById('faculty_id').value;
      const discipline_id = document.getElementById('discipline_id').value;
      const remarks = document.getElementById('remarks').value;
      const status = document.getElementById('status').value;

      const remarksValue = remarks ? remarks : "Null";

      console.log(specialization, discipline_id, faculty_id, status, remarksValue);

      http.post(`/Admin/updatespecialisation/${id2}`, { faculty_id: faculty_id, discipline_id: discipline_id, specialisation_name: specialization, remarks: remarksValue, status: status })
        .then(response => {
          console.log(response);
          if (response.data.status_code === "MSG2") {
            sessionStorage.setItem("message", "Specialisation updated successfully");
            navigate("/admin/specialization");

          }
        })
        .catch(error => {
          console.error(error);


          if (error.response && error.response.status === 500) {
            setMessage("Duplicate Value: This faculty already exists");
          } else {
            setMessage("Something Went Wrong");
          }

        });
    }
  };


  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12" >
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Edit Specialization</h5>
                    </div>
                  </div>
                  <div className="card-body">
                    {message && (
                      <div className="alert alert-danger mar2" role="alert">
                        <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                      </div>
                    )}
                    <div className="card-body pdg">
                      <div className="table-responsive">


                        <div className="form theme-form">
                          <div className="card-body custom-input">
                            <div className="row">
                              <div className="col">
                                <div className="col">
                                  <div className="mb-3 row">
                                    <label className="col-sm-3">Specialization <span className="errorclr">*</span></label>
                                    <div className="col-sm-9">
                                      <input className="form-control input-air-primary" type="text" id="specialization" name="specialization" defaultValue={specialization.specialisation_name} required placeholder="Specialization" maxLength={3} />
                                      {errors.spec_name && <p className="text-danger">{errors.spec_name}</p>}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3">Faculty Name <span className="errorclr">*</span></label>
                                    <div className="col-sm-9">
                                      <select className="form-control form-select scrollable-bar-select" id="faculty_id" name="faculty_id" onChange={isdisiplin} required>
                                        <option value="" >Select Faculty</option>

                                        {faculty.map(facultys => (

                                          <option value={facultys.id} selected={specialization.faculty_id === facultys.id ? 'selected' : null}>{facultys.faculty_name}</option>
                                        ))}

                                      </select>
                                      {errors.fac && <p className="text-danger">{errors.fac}</p>}
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3">Discipline <span className="errorclr">*</span></label>
                                    <div className="col-sm-9">
                                      <select className="form-control form-select scrollable-bar-select" id="discipline_id" name="discipline_id" required>
                                        <option value="">Select Discipline</option>
                                        {discipline.map(disciplines => (
                                          disciplines.faculty_id === facultyid && (
                                            <option
                                              key={disciplines.id}
                                              value={disciplines.id}
                                              selected={specialization.discipline_id === disciplines.id}>
                                              {disciplines.discipline_name}
                                            </option>
                                          )
                                        ))}
                                      </select>
                                      {errors.dname && <p className="text-danger">{errors.dname}</p>}

                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3">Remarks</label>
                                    <div className="col-sm-9">
                                      <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" defaultValue={specialization.remarks === 'Null' ? '' : specialization.remarks} />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <label className="col-sm-3">Status <span className="errorclr">*</span></label>
                                    <div className="col-sm-9">
                                      <select className="form-control input-air-primary" id="status" name="status" required defaultValue={specialization.status}>
                                        <option value="0">---Select---</option>
                                        <option value="active" selected={specialization.status === 'active' ? 'selected' : null}>Active</option>
                                        <option value="inactive" selected={specialization.status === 'inactive' ? 'selected' : null}>Inactive</option>
                                      </select>
                                      {errors.specstatus && <p className="text-danger">{errors.specstatus}</p>}
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>

                            <div className="col-md-12 txt-aln">
                              <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>

                          </div>



                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
